<div class="calendar-month">
  <div class="calendar-month__header">
    <div class="calendar-month__header-left">
      <button mat-icon-button (click)="onClickBack()" matTooltip="back to year">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h4 class="calendar-month__title">{{ selectedDate() | date: 'yyyy-MM' }}</h4>
    </div>
    <div class="calendar-month__header-right">
      <button mat-icon-button (click)="onClickPrevious()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button mat-icon-button (click)="onClickNext()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>
  <div class="calendar-month__wrapper">
    @for (weekday of weekdays(); track weekday) {
      <div class="calendar-month__weekday">{{ weekday }}</div>
    }
    @for (i of dayOffset(); track i) {
      <div></div>
    }
    @for (d of days(); track d; let i = $index) {
      <ng-container
        *ngTemplateOutlet="item; context: { positions: daysPositions()[i], label: d, index: i }"
      ></ng-container>
    }
  </div>
</div>
<ng-template #item let-positions="positions" let-label="label" let-index="index">
  <span
    class="calendar-month__item"
    [ngClass]="{
      active: positions?.length > 0,
      hideBackground:
        scheduleService()?.config?.hasFixRate ||
        scheduleService()?.config?.hasCommunicationInterval,
    }"
    (click)="onClickItem(index, positions?.length > 0)"
    [style.--p]="getPercent(positions?.length) + '%'"
    [attr.data-testid]="'calendar-month-' + label"
  >
    <div class="calendar-month__item-label">{{ label }}</div>
    @if (
      scheduleService()?.config?.hasFixRate || scheduleService()?.config?.hasCommunicationInterval
    ) {
      @for (position of positions; track position) {
        <div
          class="calendar-month__item-dot"
          [ngClass]="{ 'is-skip': position.isSkipped, 'is-transmitted': position.isTransmitted }"
          [ngStyle]="{ bottom: position.bottom, left: position.left }"
          [matTooltip]="getHourTooltip(position.label, position.isSkipped)"
        >
          &nbsp;
        </div>
      }
    }
  </span>
</ng-template>

<div class="calendar-month__legend">
  @if (scheduleService()?.config?.hasFixRate) {
    <div class="calendar-month__legend-transmitted"></div>
    <span>Transmission</span>
    <div class="calendar-month__legend-fix"></div>
    <span>Fix</span>
  }
  @if (scheduleService()?.config?.hasCommunicationInterval) {
    <div class="calendar-month__legend-transmitted"></div>
    <span>Transmission</span>
  }
  @if (scheduleService()?.config?.hasSkipCount) {
    <div class="calendar-month__legend-skip"></div>
    <span>Skip</span>
  }
</div>
